import React, { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import styles from '../assets/ForgotPassword.module.css';
import useAxiosSecurity from '../hooks/useAxiosSecurity';
import handleForgotPasswordRequest from '../hooks/forgotPasswordHook';
import MessageBanner from './MessageBanner';
import MultiStepTrackerWrapper from '../components/MultiStepTracker';

const { ButtonPrimary, Input, Alert, Anchor } = require('@americanexpress/dls-react');
const { EMAIL_REGEX, LOGIN_URL, FORGOT_EMAIL_SUCCESS } = require('../helper/application-conf').default;


const ForgotPassword = (props: any) => {
  const [user, setUser] = useState('');
  const { t } = useTranslation();
  const navigate = useNavigate();
  const axiosSecurity = useAxiosSecurity();
  const [hasError, setHasError] = useState(false);
  const [count, setCount] = useState(0);
  const [hasClickedForgotPassword, setHasClickedForgotPassword] = useState(false);
  const { siteName } = props;

  const showError = (flag: boolean) => {
    setCount((c) => c + 1);
    setHasError(flag);
  };

  const invalidFields = useCallback((submitting = false) => {
    if (!hasClickedForgotPassword && !submitting) {
      return [];
    }
    const invalid = [];
    if (user.length === 0) {
      invalid.push('email-required');
    }
    if ((user.length > 0 && !user.match(EMAIL_REGEX)) || user.length > 254) {
      invalid.push('email');
    }
    return invalid;
  }, [hasClickedForgotPassword, user]);

  const fieldStatus = useCallback((field: any) => {
    if (invalidFields().includes(field)) {
      return 'error';
    }
    return 'default';
  }, [invalidFields]);

  const handleForgotPassword = async () => {
    setHasClickedForgotPassword(true);
    if (invalidFields(true).length === 0) {
      handleForgotPasswordRequest(siteName, user, axiosSecurity).then(() => {
        setHasClickedForgotPassword(false);
        navigate(FORGOT_EMAIL_SUCCESS, { state: user });
        showError(false);
      }, () => {
        showError(true);
      });
    }
  };

  return (
    <div className="container">
      <div className="row pad-tb">
        <div className="col-md-offset-3 col-md-6">
          <MultiStepTrackerWrapper greyOut={true} />
        </div>
      </div>
      <div className="row">
        <div className="col-md-offset-4 col-md-4">
          <h5 className="heading-5 text-align-center pad-4-t">{t('multi_step_tracker.forgotpassword')}</h5>
          <p className="pad-4-t">{t('login.forgot_message')}</p>
        </div>
      </div>
      <span key={count}>
        <MessageBanner type="warning" messageText={t('genericError')} showMessage={hasError} />
      </span>
      <div className="row pad-2-t">
        <div className="col-md-offset-4 col-md-4">
          <Input id="user-id-input" maxLength={254} placeholder="EMAIL" required={true} onChange={(e: any) => setUser(e.target.value)} />
          {fieldStatus('email') === 'error'
            && <Alert className="pad-1-t">{t('errors.email_invalid_forgot_password')}</Alert>}
          {fieldStatus('email-required') === 'error'
            && <Alert className="pad-1-t">{t('login.email_required')}</Alert>}
        </div>
      </div>
      <div className="row">
        <div className="flex flex-column col-md-offset-4 col-md-4 pad-1-b pad-2-t text-align-center">
          <ButtonPrimary id="forgot-submit-button" onClick={handleForgotPassword} className={`${styles.fluid}`}>
            {t('submit')}
          </ButtonPrimary>
        </div>
        <div className="flex flex-column col-md-offset-4 col-md-4 pad-1-b text-align-center">
          <Anchor id="login-return-link" className="text-decoration-none" onClick={() => { navigate(LOGIN_URL); }}>
            {t('login.return_login')}
          </Anchor>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;